import React, { createContext, useContext, useState, ReactNode } from 'react';

interface AdminContextProps {
  isAdmin: boolean;
  adminRole: 0 | 1 | 2;
  adminToken: string | null;
  adminUsername: string | null;
  login: (token: string, role: 0 | 1 | 2, username: string) => void;
  logout: () => void;
}

const AdminContext = createContext<AdminContextProps | undefined>(undefined);

export const AdminProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [adminToken, setAdminToken] = useState<string | null>(
    localStorage.getItem('adminToken')
  );
  const [adminRole, setAdminRole] = useState<0 | 1 | 2>(
    (Number(localStorage.getItem('adminRole')) as 0 | 1 | 2) || 0
  );
  const [adminUsername, setAdminUsername] = useState<string | null>(
    localStorage.getItem('adminUsername')
  );

  const login = (token: string, role: 0 | 1 | 2, username: string) => {
    localStorage.setItem('adminToken', token);
    localStorage.setItem('adminRole', String(role));
    localStorage.setItem('adminUsername', username);
    setAdminToken(token);
    setAdminRole(role);
    setAdminUsername(username);
  };

  const logout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminRole');
    localStorage.removeItem('adminUsername');
    setAdminToken(null);
    setAdminRole(0);
    setAdminUsername(null);
  };

  return (
    <AdminContext.Provider value={{
      isAdmin: adminRole > 0,
      adminRole,
      adminToken,
      adminUsername,
      login,
      logout,
    }}>
      {children}
    </AdminContext.Provider>
  );
};

export const useAdmin = (): AdminContextProps => {
  const context = useContext(AdminContext);
  if (!context) {
    return {
      isAdmin: false,
      adminRole: 0,
      adminToken: null,
      adminUsername: null,
      login: () => {},
      logout: () => {},
    };
  }
  return context;
};
